import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProductDetails from './pages/ProductDetails';
import CustomerDetails from './pages/CustomerDetails';
import AffiliationGroups from './pages/AffiliationGroups';
import AffiliationGroupDetails from './pages/AffiliationGroupDetails';
import IQVIADashboard from './pages/IQVIADashboard';
import VarianceAnalysis from './pages/VarianceAnalysis';
import Layout from './components/Layout/Layout';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('novadoz_token');
    const userData = localStorage.getItem('novadoz_user');
    
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
    localStorage.setItem('novadoz_token', 'demo_token');
    localStorage.setItem('novadoz_user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem('novadoz_token');
    localStorage.removeItem('novadoz_user');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          className="w-8 h-8 border-3 border-blue-600 border-t-transparent rounded-full"
        />
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <AnimatePresence mode="wait">
          {!isAuthenticated ? (
            <Login key="login" onLogin={handleLogin} />
          ) : (
            <Layout key="dashboard" user={user} onLogout={handleLogout}>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard user={user} />} />
                <Route path="/product/:productId" element={<ProductDetails />} />
                <Route path="/customer/:customerId" element={<CustomerDetails />} />
                <Route path="/affiliation-groups" element={<AffiliationGroups />} />
                <Route path="/affiliation-group/:groupId" element={<AffiliationGroupDetails />} />
                <Route path="/variance-analysis" element={<VarianceAnalysis />} />
                <Route path="/iqvia" element={<IQVIADashboard />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          )}
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;